module.exports = __webpack_public_path__ + "img/bg-top_vrjmof.f11e835f.jpg";